import 'styles/templates/contact.scss'

import 'scripts/vue/main'
import Vue from 'vue'
import Accordion from 'scripts/vue/components/Accordion'
import AccordionItem from 'scripts/vue/components/AccordionItem'

window.PSTheme.Vue.FAQ = new Vue({
  name: 'FAQ',

  components: { Accordion, AccordionItem },

  data () {
    return {
      activeIdx: 0
    }
  }
}).$mount('.contact__faq')
